<script setup lang="ts">
import PlusSmallIcon from '@/assets/icons/PlusSmallIcon.vue';

const emit = defineEmits<{
  request: [anchor: HTMLElement];
}>();

const request = (event: MouseEvent): void => {
  emit('request', event.currentTarget as HTMLElement);
};
</script>

<template>
  <li>
    <button
      type="button"
      class="flex min-h-12 w-full items-center gap-smd rounded-md py-sm pl-sm pr-md text-left text-secondary state-effects"
      @click="request"
    >
      <span class="flex size-8 shrink-0 items-center justify-center rounded-full bg-surface-secondary">
        <PlusSmallIcon class="size-icon-smd" />
      </span>
      <span class="text-body">{{ $t('general.add') }}</span>
    </button>
  </li>
</template>
